<template lang="pug">
  .the-b2b-profile-contact
    ods-form(ref='contactDataForm' :model='form' :rules='validationRules' status-icon)
      ods-module
        ods-row(:gutter='20')
          ods-col(:xs='24' :sm='10' :lg='10')
            ods-form-item(prop='type')
              ods-select(v-model='form.type' prop='type' :placeholder='$t("profile.contact.contact_data_form.type.placeholder")', @change='typeHasChanged' :disabled='canNoEditUserData')
                ods-option(v-for='type in types' :key='type.id' :label='$t("mediaType." + type.media)' :value='type.id')
          ods-col(:xs='24' :sm='10' :lg='10')
            ods-form-item(prop='contact')
              ods-input(v-model='form.contact')
          ods-col(:xs='24' :sm='4' :lg='4')
            ods-row.right-align
              ods-button(
                icon='ods-icon-plus',
                size='small',
                circle,
                :disabled='canNoEditUserData',
                @click.native='addContactData')
                | {{ $t('buttons.btnAdd') }}
        div(style='display: flex;')
            b2b-tags-component(
              :tags='contacts',
              :isFilter='false',
              @when-remove-all='removeAllContactData',
              @when-remove='removeContact'
              )
      ods-row.form-actions
        ods-button(type='primary' @click='saveContactData' round :disabled='saveButtonDisabled').is-shadow
          | {{ $t('buttons.btnSaveChanges') }}
        ods-button(v-if='!hideCancelButton' type='neutral' @click='cancel')
          | {{ $t('buttons.btnCancel') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTagsComponent from '@/components/B2bTagsComponent'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-profile-contact',
  mixins: [Utils],
  data () {
    const self = this
    const validateContact = (rule, value, callback) => {
      if (
        self.$data.form.type === undefined ||
        self.$data.form.type === null ||
        self.$data.form.type === 0
      ) {
        callback()
      } else {
        if (self.$data.form.type !== 1 && self.$data.form.type !== 7) {
          if (self.checkCorrectPhoneNumber(value)) {
            callback()
          } else {
            callback(new Error(this.$t('profile.contact.rules_form.phone_format')))
          }
        } else if (self.$data.form.type === 1) {
          if (this.checkCorrectEmail(value)) {
            callback()
          } else {
            callback(new Error(this.$t('profile.contact.rules_form.email_format')))
          }
        } else {
          callback()
        }
      }
    }

    return {
      saveButtonDisabled: true,
      hideCancelButton: true,
      types: [],
      form: {
        type: null,
        contact: null
      },
      validationRules: {
        type: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        contact: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 255,
            message: this.$t('msg_generics.max_num_character', { max: 255 }),
            trigger: 'change'
          },
          {
            validator: validateContact,
            trigger: 'change'
          }
        ]
      },
      contacts: [],
      user: {}
    }
  },

  computed: { ...mapGetters(['activeUser', 'canNoEditUserData']) },

  components: {
    B2bTagsComponent
  },

  methods: {
    ...mapActions([
      'getMyUserMedia',
      'getUserByUsername',
      'addMyUserMedia',
      'deleteAllUserMedia',
      'getOptionsMediaType'
    ]),

    createTagFromObject (contact) {
      console.log(contact)
      return {
        id: contact.id !== null ? contact.id : null,
        value: contact.typeLabel,
        query: contact.contact,
        object: contact
      }
    },

    async addContactData () {
      const validation = await this.$refs.contactDataForm
        .validate()
        .catch(() => false)
      if (validation) {
        const type = this.types.filter(t => t.id === this.form.type)
        let contact = {
          typeLabel: type[0].description,
          type: this.form.type,
          contact: this.form.contact
        }

        // Validamos que no se repiten los tipos de media type

        const mediaType = this.contacts.filter(function (option) {
          return option.object.type === type[0].media
        })

        if (mediaType.length > 0) {
          const errorSms = this.$t('profile.contact.rules_form.contact_media_exist')
          this.$notify({
            title: errorSms,
            type: 'error',
            position: 'top-right',
            customClass: 'b2b-notification-error',
            duration: 10000
          })
        } else {
          contact = this.createTagFromObject(contact)
          this.contacts.push(contact)
          this.resetForm()
          if (!this.canNoEditUserData) {
            this.saveButtonDisabled = false
          }
          this.hideCancelButton = false
        }
      }
    },

    removeAllContactData () {
      this.contacts = []
      this.saveButtonDisabled = true
      this.hideCancelButton = false
    },

    removeContact (contact) {
      if (!this.canNoEditUserData) {
        this.saveButtonDisabled = false
      }
      this.hideCancelButton = false

      // Quitamos de la lista el elemento removido en caso de existir
      for (let i = 0; i < this.contacts.length; i++) {
        if (this.contacts[i].query === contact.query) {
          this.contacts.splice(i, 1)
        }
      }
      if (!this.contacts || this.contacts.length === 0) {
        this.saveButtonDisabled = true
      }
    },

    resetForm () {
      this.$refs.contactDataForm.resetFields()
    },

    typeHasChanged () {
      this.$refs.contactDataForm.validate().catch(() => false)
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 404:
        case 409:
          errorSms = error.data.message
          break
        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },

    // Carga datos de contacto
    async getUserContact () {
      try {
        this.user = await this.getUserByUsername(this.activeUser.data.username)
        const response = await this.getMyUserMedia()
        // construir los tags
        for (const c of response) {
          console.log('valor de c: ', c)
          let contact = {
            id: c.id,
            typeLabel: this.$t('mediaType.' + c.mediaTypeName),
            type: c.mediaType,
            typeName: c.mediaTypeName,
            contact: c.value
          }
          contact = this.createTagFromObject(contact)
          this.contacts.push(contact)
        }
      } catch (error) {
        console.log('getUserContact CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    // Guarda datos de contacto
    async saveContactData () {
      const load = this.$loading({
        lock: true,
        text: this.$t('profile.contact.load.add_user_media')
      })
      try {
        console.log('this.contacts: ', this.contacts)

        let addContactData = false
        if (this.contacts && this.contacts.length > 0) {
          for (let i = 0; i < this.contacts.length; i++) {
            if (this.contacts[i].object.type === 'email' || this.contacts[i].object.type === 1) {
              addContactData = true
            }
          }
        }
        console.log('addContactData: ', addContactData)
        if (!addContactData) {
          const errorSms = this.$t('profile.contact.rules_form.no_contact_media_exist')
          this.$notify({
            title: errorSms,
            type: 'error',
            position: 'top-right',
            customClass: 'b2b-notification-error',
            duration: 10000
          })
        } else {
        // Eliminamos los datos de contacto previos
          await this.deleteAllUserMedia(null)
          // Guardamos los contactos nuevos
          for (const c of this.contacts) {
            const mediaType = this.types.filter(function (option) {
              return option.id === c.object.type
            })
            console.log('mediaType[0]: ', mediaType[0])
            const dataQuery = {
              query: {
                type: mediaType[0].media,
                value: c.object.contact
              }
            }
            await this.addMyUserMedia(dataQuery)
          }

          // Reseteamos listas
          await this.cancel()

          this.$notify({
            title: this.$t('profile.notify.changes_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }
      } catch (error) {
        console.log('getUserRolesAuthoritiesOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async cancel () {
      this.saveButtonDisabled = true
      this.hideCancelButton = true
      this.resetForm()
      this.contacts = []
      // Actualizamos
      await this.getUserContact()
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      this.types = await this.getOptionsMediaType()
      await this.getUserContact()
    } catch (error) {
      console.log('CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.the-b2b-profile-contact {
  margin: 3rem;
  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
      ::v-deep .the-b2b-tags-component {
        &__group {
          padding: rem(0);
          margin-left: -rem(10);
          margin-right: -rem(10);
          .ods-button {
            padding-left: rem(0);
          }
        }
      }
    }
    span.ods-tag.ods-tag--secondary.ods-tag--light.ods-tag--is-closable {
      color: var(--color-txt-primary) !important;
      background-color: transparent !important;
    }
    .ods-tag .ods-icon-close {
      font-size: 0.8rem !important;
      margin-left: 0.5rem !important;
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }
}
</style>
